import purchaseApi from "../../../api/account/purchase";

const state = {
  list: {}
};

const getters = {};

const mutations = {
  // 存首页的列表
  setLst(state, { data }) {
    state.list = data;
  },
  // 修改收藏状态
  collect(state, { data }) {
    state.list.formatList.find(v => {
      if (v.propertyId == data.id) {
        if (data.type == "no") {
          v.favoritesFlag = "yes";
        } else {
          v.favoritesFlag = "no";
        }
      }
    });
  }
};

const actions = {
  // 获取列表
  getLst({ state }, { params, callback }) {
    console.log(state);
    purchaseApi.getLstApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取详情
  getPropertyDtl({ state }, { params, callback }) {
    console.log(state);
    purchaseApi.getPropertyDtlApi({ params, callback }, res => {
      callback(res);
    });
  },
  // 获取pdf
  getPdf({ state }, { params, callback }) {
    console.log(state);
    purchaseApi.getPdfApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/purchase.js